import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from 'react';
import ReactDOM from 'react-dom';

import {
    BrowserRouter as Router,
} from "react-router-dom";

import { Provider } from "react-redux";
import store from "./redux/index.js";
import App from './App';
import theme from "./themeConfig";
import { ThemeProvider } from "@material-ui/core/styles";

ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <Router>
                <App />
            </Router>
        </ThemeProvider>
    </Provider>,

    document.getElementById('root')
);

